import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TemplateComponent} from './template/template.component';
import {TemplateSomenteCorpoComponent} from './template-somente-corpo/template-somente-corpo.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/simulacao/credito-imobiliario',
    pathMatch: 'full'
  },
  {
    path: 'simulacao',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/simulacao/simulacao.module').then(m => m.SimulacaoModule)
      }
    ]
  },
  {
    path: 'simulacao-body',
    component: TemplateSomenteCorpoComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/simulacao/simulacao.module').then(m => m.SimulacaoModule),
      }
    ]
  },
  {
    path: 'usuario',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/usuario/usuario.module').then(m => m.UsuarioModule)
      }
    ]
  },
  {
    path: 'usuario-body',
    component: TemplateSomenteCorpoComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/usuario/usuario.module').then(m => m.UsuarioModule),
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
